const PREFIX = 'https://d35osugjxh1z9n.cloudfront.net';

// Map aspect ratio and video template id into a video asset and duration in seconds.
export const THREE_SIXTY_PREVIEW_VIDEOS = {
  '16:9': {
    '02c34216-e887-4241-8201-32bea4f72c3f': { video: `${PREFIX}/landscape/NoVFX15.mp4`, duration: 15 },
    '02c34216-e887-4241-8201-32bed7e72c3f': { video: `${PREFIX}/landscape/NoVFX30.mp4`, duration: 30 },
    '02c34216-e887-4241-8201-32bec1c72c3f': { video: `${PREFIX}/landscape/Slowmotion15.mp4`, duration: 15 },
    'dd54b613-ed4e-46b0-9c03-bb524f86e548': { video: `${PREFIX}/landscape/FastSlowReverse215.mp4`, duration: 15 },
    'cff45dbc-ab5f-4e94-b74d-df99d8ea788b': { video: `${PREFIX}/landscape/FastSlowReverse15.mp4`, duration: 15 },
    '3c4c4288-8e29-4dde-9dc1-4cb7b4d8b6cb': { video: `${PREFIX}/landscape/FastSlowReverse30.mp4`, duration: 30 },
    '4b5c6e57-99f7-4d52-8fbd-603b309bf2ad': { video: `${PREFIX}/landscape/FastSlowReverse230.mp4`, duration: 30 },
  },
  '9:16': {
    '02c34216-e887-4241-8201-32bea4f72c3f': { video: `${PREFIX}/portrait/NoVFX15.mp4`, duration: 15 },
    '02c34216-e887-4241-8201-32bed7e72c3f': { video: `${PREFIX}/portrait/NoVFX30.mp4`, duration: 30 },
    '02c34216-e887-4241-8201-32bec1c72c3f': { video: `${PREFIX}/portrait/Slowmotion15.mp4`, duration: 15 },
    'dd54b613-ed4e-46b0-9c03-bb524f86e548': { video: `${PREFIX}/portrait/FastSlowReverse215.mp4`, duration: 15 },
    'cff45dbc-ab5f-4e94-b74d-df99d8ea788b': { video: `${PREFIX}/portrait/FastSlowReverse15.mp4`, duration: 15 },
    '3c4c4288-8e29-4dde-9dc1-4cb7b4d8b6cb': { video: `${PREFIX}/portrait/FastSlowReverse30.mp4`, duration: 30 },
    '4b5c6e57-99f7-4d52-8fbd-603b309bf2ad': { video: `${PREFIX}/portrait/FastSlowReverse230.mp4`, duration: 30 },
  },
  '1:1': {
    '02c34216-e887-4241-8201-32bea4f72c3f': { video: `${PREFIX}/square/NoVFX15.mp4`, duration: 15 },
    '02c34216-e887-4241-8201-32bed7e72c3f': { video: `${PREFIX}/square/NoVFX30.mp4`, duration: 30 },
    '02c34216-e887-4241-8201-32bec1c72c3f': { video: `${PREFIX}/square/Slowmotion15.mp4`, duration: 15 },
    'dd54b613-ed4e-46b0-9c03-bb524f86e548': { video: `${PREFIX}/square/FastSlowReverse215.mp4`, duration: 15 },
    'cff45dbc-ab5f-4e94-b74d-df99d8ea788b': { video: `${PREFIX}/square/FastSlowReverse15.mp4`, duration: 15 },
    '3c4c4288-8e29-4dde-9dc1-4cb7b4d8b6cb': { video: `${PREFIX}/square/FastSlowReverse30.mp4`, duration: 30 },
    '4b5c6e57-99f7-4d52-8fbd-603b309bf2ad': { video: `${PREFIX}/square/FastSlowReverse230.mp4`, duration: 30 },
  },
};

export const THREE_SIXTY_MODE_SUCCESS_MESSAGE = {
  videoTemplate: 'The 360 Video Template was successfully changed.',
  overlay: 'The 360 Overlay was successfully changed.',
  soundtrack: 'The 360 Shoudtrack was successfully changed.',
  aspectRatio: 'The 360 Aspect Ratio was successfully changed.',
  numberOfRotations: "The Tortilla's Number of Rotations was successfully changed.",
  armSpeed: "The Tortilla's Arm Speed was successfully changed.",
  intro: 'The 360 Intro video was successfully changed.',
  outro: 'The 360 Outro video was successfully changed.',
};
